import { useState } from 'react'
import '../App.css'

function ApagarContaUsuario() {

    return (
        <>
            <div>
                <h1>Apagar Conta do Usuário ScottClub</h1>
            </div>
        </>
    )
}

export default ApagarContaUsuario
